import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../../StateContext/Application'
import { apiurl } from '../../../../../path'

const FundOutwardList = () => {
    const context = useContext(AdminContext)
    const { GetAllFundList, Usermenu } = context
    const [fund, setfundList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const [menuData, setMenuData] = useState(null);
    const getFundList = async () => {
        let data = await GetAllFundList()
        console.log("data", data);
        if (Array.isArray(data)) {
            setfundList(data);
            setFilteredBills(data);
        } else {
            setfundList([]);
            setFilteredBills([]);
        }
    }
    useEffect(() => {
        getFundList()
    }, [])
    let fundList = []
    if (fund.length > 0) {
        fundList = fund
    }
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = fund.filter(bill =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1); // Reset to page 1 on search
    }, [searchTerm, fund]);

    useEffect(() => {
        const getMenu = async () => {
            const res = await Usermenu();
            console.log(res);
            setMenuData(res.Data);
        };

        getMenu();
    }, []);
    const isMaker =
        menuData?.Department_Name === "State Maker" &&
        menuData?.Role === "State Maker";

    const isChecker =
        menuData?.Department_Name === "State Checker" &&
        menuData?.Role === "State Checker";
    console.log("menuData", menuData);
    return (

        <div style={{
            background: '#efecff',
            width: 'auto',
            maxHeight: "92vh",
            // minHeight: '100vh',  
            transition: "margin-left 0.3s ease",
            overflowY: "auto",
            msOverflowStyle: "none",       // IE & Edge
            scrollbarWidth: "none",
            padding: 40,
            fontFamily: 'Inter, sans-serif'
        }}>
            <div style={{
                display: "grid",
                justifyContent: "center",
                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                borderRadius: "10px",
                // width: "75vw",
                backgroundColor: "white",
                padding: "20px 25px",
                minHeight: "81vh",
                overflow: "auto"
            }}>

                {/* ---- Header Section ---- */}
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                    padding: "0 20px",
                    width: "100%",
                }}>
                    <h5 style={{
                        fontWeight: "bold",
                        color: "black",
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <img
                            src={"/List-32.png"}
                            alt="Project Icon"
                            style={{ marginRight: "10px", width: 28, height: 28 }}
                        />
                        Fund Allocation List
                    </h5>

                    {/* ---- Search Box ---- */}
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "aliceblue",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        padding: "5px 10px",
                        width: "250px",
                    }}>
                        <img
                            src={"/Search-32.png"}
                            alt="Search Icon"
                            style={{ width: 20, height: 20, marginRight: "8px" }}
                        />
                        <input
                            type="text"
                            placeholder="Search Fund..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                border: "none",
                                outline: "none",
                                background: "transparent",
                                width: "100%",
                                fontSize: "14px",
                            }}
                        />
                    </div>
                </div>

                {/* ---- Table Section ---- */}
                <div style={{ overflowX: "auto", width: "100%" }}>
                    <table style={{ backgroundColor: "white", width: "100%", minWidth: "1200px", borderCollapse: "collapse" }}>
                        <thead >
                            <tr style={{ backgroundColor: "#2ea4e7", color: "white", fontSize: "13px", fontWeight: "600", textAlign: "center", whiteSpace: "nowrap" }}>
                                <th style={{ padding: "10px" }}>ReleaseID</th>
                                <th style={{ padding: "10px" }}>FinancialYear</th>
                                <th style={{ padding: "10px" }}>ProjectName</th>
                                {/* <th style={{ padding: "10px" }}>CRC</th>
                                <th style={{ padding: "10px" }}>BudgetHead</th> */}
                                <th style={{ padding: "10px" }}>ReleaseAmount</th>
                                <th style={{ padding: "10px" }}>ReleaseDate</th>
                                <th style={{ padding: "10px" }}>ReleaseSanctionCopy</th>
                                <th style={{ padding: "10px" }}>Checker Approval</th>
                                <th style={{ padding: "10px" }}>Admin Approval</th>
                                {isMaker && (<th style={{ padding: "10px" }}>Remark</th>)}
                            </tr>
                        </thead>
                        {
                            currentBills?.map((fund, index) => {
                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                    <tbody key={index}>
                                        <tr style={{ fontSize: "13px", fontWeight: "500", textAlign: "center", whiteSpace: 'nowrap', backgroundColor: index % 2 === 0 ? "#f4f7fe" : "white" }}>
                                            <td style={{ padding: "10px" }}>{fund.ReleaseID}</td>
                                            <td style={{ padding: "10px" }}>{fund.FinancialYear}</td>
                                            <td style={{ padding: "10px" }}>{fund.ProjectName}</td>
                                            {/* <td style={{ padding: "10px" }}>{fund.CRC}</td>
                                            <td style={{ padding: "10px" }}>{fund.BudgetHead}</td> */}
                                            <td style={{ padding: "10px" }}>{fund.ReleaseAmount}</td>
                                            <td style={{ padding: "10px" }}>{fund.ReleaseDate?.split('T')[0].replace(' ')}</td>
                                            <td style={{ padding: "10px" }}>{fund.ReleaseSanctionCopy}</td>
                                            <td style={{ padding: "10px" }}>{fund.Approval1}</td>
                                            <td style={{ padding: "10px" }}>{fund.Approval2}</td>
                                            {isMaker && (<td style={{ padding: "10px" }}>{fund.Remark}</td>
                                            )}
                                        </tr>
                                    </tbody>
                                )
                            })
                        }
                    </table>
                </div>

                {/* ---- Pagination ---- */}
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "20px",
                }}>
                    <div>
                        <p style={{ fontSize: "18px", color: "black" }}>
                            Showing {Math.min(indexOfFirstBill + 1, filteredBills?.length)} to{" "}
                            {Math.min(indexOfLastBill, filteredBills?.length)} of {filteredBills?.length} entries
                        </p>
                    </div>

                    <div style={{ display: "flex" }}>
                        <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                            style={{
                                padding: "8px 10px",
                                fontSize: "18px",
                                fontWeight: "bold",
                                width: "2rem",
                                height: "2.5rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
                                color: "#044c92",
                                border: "1px solid #cccccc",
                                cursor: "pointer",
                                transition: "0.2s ease-in-out",
                            }}>
                            &laquo;
                        </button>

                        <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
                            style={{
                                padding: "8px 10px",
                                fontSize: "18px",
                                fontWeight: "bold",
                                width: "2rem",
                                height: "2.5rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
                                color: "#044c92",
                                border: "1px solid #cccccc",
                                cursor: "pointer",
                                transition: "0.2s ease-in-out",
                            }}>
                            &lt;
                        </button>

                        <button style={{
                            padding: "8px 10px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            width: "2rem",
                            height: "2.5rem",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "linear-gradient(to bottom, #044c92 , #0071bc , #022f5a )",
                            color: "white",
                            border: "1px solid #cccccc",
                        }}>
                            {currentPage}
                        </button>

                        <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
                            style={{
                                padding: "8px 10px",
                                fontSize: "18px",
                                fontWeight: "bold",
                                width: "2rem",
                                height: "2.5rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: currentPage === totalPages ? "#ffffff" : "#e5f4fb",
                                color: "#044c92",
                                border: "1px solid #cccccc",
                                cursor: "pointer",
                                transition: "0.2s ease-in-out",
                            }}>
                            &gt;
                        </button>

                        <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
                            style={{
                                padding: "8px 10px",
                                fontSize: "18px",
                                fontWeight: "bold",
                                width: "2rem",
                                height: "2.5rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: currentPage === totalPages ? "#ffffff" : "#e5f4fb",
                                color: "#044c92",
                                border: "1px solid #cccccc",
                                cursor: "pointer",
                                transition: "0.2s ease-in-out",
                            }}>
                            &raquo;
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FundOutwardList
